import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Icon } from '../Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var WordSvg = function WordSvg() {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 25 24",
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#word__a)",
      children: [/*#__PURE__*/_jsx("path", {
        fill: "#41A5EE",
        d: "M21.783 2H7.116a.917.917 0 0 0-.916.917V7l8.5 2.5 8-2.5V2.917A.917.917 0 0 0 21.783 2"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#2B7CD3",
        d: "M22.7 7H6.2v5l8.5 1.5 8-1.5z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#185ABD",
        d: "M6.2 12v5l8 1 8.5-1v-5z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#103F91",
        d: "M7.116 22h14.667a.917.917 0 0 0 .917-.916V17H6.2v4.084a.917.917 0 0 0 .916.916"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#000",
        d: "M12.283 6H6.2v12.5h6.083a.92.92 0 0 0 .917-.916V6.917A.92.92 0 0 0 12.283 6",
        opacity: 0.1
      }), /*#__PURE__*/_jsx("path", {
        fill: "#000",
        d: "M11.783 6.5H6.2V19h5.583a.92.92 0 0 0 .917-.916V7.417a.92.92 0 0 0-.917-.917",
        opacity: 0.2
      }), /*#__PURE__*/_jsx("path", {
        fill: "#000",
        d: "M11.783 6.5H6.2V18h5.583a.92.92 0 0 0 .917-.916V7.417a.92.92 0 0 0-.917-.917",
        opacity: 0.2
      }), /*#__PURE__*/_jsx("path", {
        fill: "#000",
        d: "M11.283 6.5H6.2V18h5.083a.92.92 0 0 0 .917-.916V7.417a.92.92 0 0 0-.917-.917",
        opacity: 0.2
      }), /*#__PURE__*/_jsx("path", {
        fill: "url(#word__b)",
        d: "M11.283 6.5H2.116a.916.916 0 0 0-.916.917v9.167c0 .506.41.916.916.916h9.167c.506 0 .917-.41.917-.916V7.417a.916.916 0 0 0-.917-.917"
      }), /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        d: "M4.96 13.529q.028.212.036.37h.021q.012-.15.05-.361.037-.212.069-.358L6.1 9.021h1.246l1 4.096q.087.383.125.773h.016q.028-.378.104-.75L9.39 9.02h1.134l-1.4 5.96H7.796l-.95-3.947a9 9 0 0 1-.158-.844h-.017a9 9 0 0 1-.064.431q-.048.287-.077.425l-.893 3.934H4.29L2.88 9.021h1.155l.869 4.167q.03.13.056.341"
      })]
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("linearGradient", {
        id: "word__b",
        x1: 3.111,
        x2: 10.289,
        y1: 5.784,
        y2: 18.216,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#2368C4"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 0.5,
          stopColor: "#1A5DBE"
        }), /*#__PURE__*/_jsx("stop", {
          offset: 1,
          stopColor: "#1146AC"
        })]
      }), /*#__PURE__*/_jsx("clipPath", {
        id: "word__a",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M.2 0h24v24H.2z"
        })
      })]
    })]
  });
};
export var Word = function Word(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, props), {}, {
    component: WordSvg
  }));
};